import {
  ProductListItemsBase,
  ProductItemsGridProps,
  AddProductsToCartForm,
} from '@graphcommerce/magento-product'
import { ReactNode } from 'react'
import { productListRenderer } from './productListRenderer'

export type ProductListItemsProps = Omit<ProductItemsGridProps, 'renderers'> & {
  pagination?: ReactNode;
}

export function ProductListItems(props: ProductListItemsProps) {

  return (
    <ProductListItemsBase renderers={productListRenderer} pagination={props?.pagination} {...props} />
  )
}
